import { gql } from "@apollo/client";

const SETUP_PROPOSAL_FIELDS = gql`
    fragment SetupProposalFields on SetupProposal {
        id
        operationId
        summary
        rationale
        risk
        status
        body
        error
        appliedAt
        createdAt
    }
`;

const SETUP_SESSION_FIELDS = gql`
    ${SETUP_PROPOSAL_FIELDS}
    fragment SetupSessionFields on SetupAssistantSession {
        id
        status
        scopes
        expiresAt
        messages {
            role
            content
            createdAt
            toolCalls {
                name
                operationId
                ok
            }
        }
        proposals {
            ...SetupProposalFields
        }
    }
`;

export const GET_SETUP_CHECKLIST = gql`
    query GetSetupChecklist($organizationId: ID!) {
        setupChecklist(organizationId: $organizationId) {
            complete
            completedCount
            totalCount
            requiredRemaining
            items {
                id
                title
                complete
                detail
                required
            }
        }
    }
`;

export const GET_SETUP_ASSISTANT_SESSION = gql`
    ${SETUP_SESSION_FIELDS}
    query GetSetupAssistantSession($sessionId: ID!) {
        setupAssistantSession(sessionId: $sessionId) {
            ...SetupSessionFields
        }
    }
`;

export const GET_SETUP_HINT = gql`
    query GetSetupHint($organizationId: ID!, $hintKey: String!) {
        setupHint(organizationId: $organizationId, hintKey: $hintKey) {
            hintKey
            title
            questions
        }
    }
`;

export const START_SETUP_ASSISTANT_SESSION = gql`
    ${SETUP_SESSION_FIELDS}
    mutation StartSetupAssistantSession($organizationId: ID!) {
        startSetupAssistantSession(organizationId: $organizationId) {
            ...SetupSessionFields
        }
    }
`;

export const SEND_SETUP_ASSISTANT_MESSAGE = gql`
    ${SETUP_SESSION_FIELDS}
    mutation SendSetupAssistantMessage($sessionId: ID!, $message: String!) {
        sendSetupAssistantMessage(sessionId: $sessionId, message: $message) {
            reply
            newProposalIds
            session {
                ...SetupSessionFields
            }
        }
    }
`;

export const APPLY_SETUP_PROPOSAL = gql`
    ${SETUP_PROPOSAL_FIELDS}
    mutation ApplySetupProposal($sessionId: ID!, $proposalId: ID!) {
        applySetupProposal(sessionId: $sessionId, proposalId: $proposalId) {
            ...SetupProposalFields
        }
    }
`;

export const DISMISS_SETUP_PROPOSAL = gql`
    ${SETUP_PROPOSAL_FIELDS}
    mutation DismissSetupProposal($sessionId: ID!, $proposalId: ID!) {
        dismissSetupProposal(sessionId: $sessionId, proposalId: $proposalId) {
            ...SetupProposalFields
        }
    }
`;

export const END_SETUP_ASSISTANT_SESSION = gql`
    mutation EndSetupAssistantSession($sessionId: ID!) {
        endSetupAssistantSession(sessionId: $sessionId)
    }
`;

export const MARK_SETUP_HINT_SHOWN = gql`
    mutation MarkSetupHintShown($organizationId: ID!, $hintKey: String!) {
        markSetupHintShown(organizationId: $organizationId, hintKey: $hintKey)
    }
`;

export const DISMISS_SETUP_HINT = gql`
    mutation DismissSetupHint($organizationId: ID!, $hintKey: String!, $openedAssistant: Boolean) {
        dismissSetupHint(organizationId: $organizationId, hintKey: $hintKey, openedAssistant: $openedAssistant)
    }
`;
